module.exports = __webpack_public_path__ + "static/img/3_3.abeac5c8.jpg";